<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-container>
          <v-layout wrap pb-lg-12>
            <v-flex xs12 pb-5 py-1 style="color: #8e8e8e">
              <router-link
                style="text-decoration: none; color: #8e8e8e"
                :to="{ name: 'cart' }"
              >
                Cart >
              </router-link>
              <!-- <router-link
              style="text-decoration: none; color: #8e8e8e"
              :to="{ name: 'cartinformation' }"
            >
              Information >
            </router-link> -->
              <router-link
                style="text-decoration: none; color: #8e8e8e"
                :to="{ name: 'cartshipping' }"
              >
                Shipping >
              </router-link>
              <router-link
                style="text-decoration: none; color: #8e8e8e"
                :to="{ name: 'cartpayment' }"
              >
                <span style="color: black"> Payment</span>
              </router-link>
            </v-flex>
            <v-flex xs12 sm6>
              <v-layout wrap>
                <v-flex xs12>
                  <v-card outlined style="border-radius: 1px">
                    <v-layout wrap pa-2 pa-lg-2>
                      <v-flex xs3 md2 style="color: #8e8e8e"> Contact </v-flex>
                      <v-flex xs6 md9>
                        <div>{{ ship.phone }}</div>
                        <div>{{ ship.email }}</div>
                      </v-flex>
                      <!-- <v-flex
                        xs3
                        md2
                        @click="editShip(ship)"
                        text-right
                        style="
                          font-family: robotoregular;
                          font-size: 14px;
                          cursor: pointer;
                        "
                        >Change
                      </v-flex> -->
                      <!-- <v-flex xs12 py-3> <v-divider></v-divider> </v-flex> -->
                      <v-flex pb-5 xs3 md2 style="color: #8e8e8e">
                        Shipping <br />
                        Address
                      </v-flex>
                      <v-flex xs7 md8>
                        <div>{{ ship.address }}</div>
                        <div>{{ ship.pincode }}</div>
                      </v-flex>
                      <!-- <v-flex
                      xs2
                      text-right
                      style="font-family: robotoregular; font-size: 14px"
                      >Change
                    </v-flex> -->
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 pt-5 style="font: 20px robotomedium"
                  >Payment
                </v-flex>
                <v-flex xs12 pb-3
                  >All transactions are secure and encrypted
                </v-flex>
                <v-flex xs12>
                  <v-card outlined style="border-radius: 1px">
                    <v-layout justify-center wrap py-4 px-3>
                      <v-flex xs12>
                        <v-radio-group v-model="column">
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-radio
                                label="Add Credit or Debit Card Details"
                                value="Add Credit or Debit Card Details"
                                color="balck"
                              ></v-radio>
                            </v-flex>
                            <v-flex xs10 py-5 pl-lg-8 text-center>
                              <v-img
                                width="60px"
                                src="../../assets/visa.png"
                              ></v-img>
                            </v-flex>
                            <v-flex xs12>
                              <v-radio
                                style="padding-top: 2%; padding-bottom: 2%"
                                label="Net Banking"
                                value="Net Banking"
                                color="balck"
                              ></v-radio>
                            </v-flex>
                            <v-flex xs12>
                              <v-radio
                                style="padding-bottom: 2%"
                                label="Other UPI"
                                value="Other UPI"
                                color="balck"
                              ></v-radio>
                            </v-flex>
                            <v-flex xs12>
                              <v-radio
                                label="Pay On Delivery"
                                value="Pay On Delivery"
                                color="balck"
                              ></v-radio>
                            </v-flex>
                          </v-layout>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 pt-5 style="font: 20px robotomedium"
                  >PaymentBilling Address
                </v-flex>
                <v-flex xs12 pb-3
                  >Select the address that matches your card or payment method.
                </v-flex>
                <v-flex xs12>
                  <v-card outlined style="border-radius: 1px">
                    <v-radio-group>
                      <v-layout wrap pa-2 pa-lg-2>
                        <v-flex xs12>
                          <v-radio
                            style="padding-bottom: 2%"
                            label="Same as Shipping Address"
                            value="Other UPI"
                            color="balck"
                          ></v-radio>
                        </v-flex>
                        <v-flex xs12 px-1>
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 pt-3>
                          <v-radio
                            style="padding-bottom: 2%"
                            label="Use a Different Billing Address"
                            value="Other UP"
                            color="balck"
                          ></v-radio>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-card>
                </v-flex>
                <v-flex pt-5 xs12 sm12 md12 lg12 pt-lg-8>
                  <v-layout wrap>
                    <v-flex xs12 sm12 lg5 pb-3 pb-sm-0>
                      <v-btn
                        color="yellow"
                        tile
                        width="100%"
                        style="text-transform: none; color: white"
                        elevation="0"
                        >CONTINUE TO PAYMENT
                      </v-btn>
                    </v-flex>
                    <v-flex pl-lg-4 xs12 sm12 md12 lg5 pt-sm-5 pt-md-3 pt-lg-0>
                      <router-link
                        :to="'/cartshipping'"
                        style="text-decoration: none"
                      >
                        <v-btn tile width="100%" outlined
                          >RETURN TO SHIPPING</v-btn
                        >
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-dialog v-model="editdialog" max-width="600px">
              <v-card>
                <v-card-text>
                  <v-layout justify-center wrap>
                    <v-flex
                      xs12
                      pb-3
                      pb-lg-5
                      pt-5
                      style="font: 20px robotomedium"
                      >Shipping Address
                    </v-flex>
                    <v-flex sm6 pr-sm-1>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        v-model="editingitem.firstName"
                        label="First Name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex sm6 pl-sm-1>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        v-model="editingitem.lastName"
                        label="Last Name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        v-model="editingitem.email"
                        label="Email"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        v-model="editingitem.company"
                        tile
                        label="Company ( Optional)"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        v-model="editingitem.address"
                        label="Address"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        label="Apartment, Suite, etc"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        v-model="editingitem.city"
                        label="City"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex sm4 pr-sm-1>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        v-model="editingitem.country"
                        tile
                        label="Country"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex sm4 px-sm-1>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        tile
                        v-model="editingitem.state"
                        label="State"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex sm4 pl-sm-1>
                      <v-text-field
                        class="textfd"
                        dense
                        outlined
                        v-model="editingitem.pincode"
                        tile
                        label="Pin"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        style="height: 26px"
                        color="grey"
                        class="textfd"
                        dense
                        outlined
                        v-model="editingitem.phone"
                        label="Phone"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout justify-center wrap>
                    <v-flex xs6 sm4 px-2>
                      <v-btn
                        block
                        tile
                        color="#757575"
                        outlined
                        :ripple="false"
                        depressed
                        @click="editdialog = false"
                        >Cancel</v-btn
                      >
                    </v-flex>
                    <v-flex xs6 sm4 px-2>
                      <v-btn
                        tile
                        block
                        dark
                        color="#FEBD08"
                        depressed
                        class="text-capitalize"
                        :ripple="false"
                        @click="edit(editingitem._id)"
                        >save</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-flex xs12 sm6 pl-sm-5 pt-6 pt-md-0 pl-lg-12>
              <v-layout wrap pl-lg-7>
                <v-flex xs12 py-lg-8>
                  <v-card flat v-for="(item, i) in cart" :key="i">
                    <v-layout wrap py-lg-3>
                      <v-flex xs2>
                        <v-img :src="mediaURL + item.productId.photos[0]">
                        </v-img>
                      </v-flex>
                      <v-flex xs6 pl-3>
                        <div style="font-family: robotobold">
                          {{ item.productId.productName }}
                        </div>
                        <div
                          style="
                            font-family: robotoregular;
                            font-size: 12px;
                            color: grey;
                          "
                        >
                          <span>QTY.{{ item.quantity }} </span>
                        </div>
                      </v-flex>
                      <v-flex xs4 style="font-family: robotobold" text-right>
                        Rs. {{ item.amount }}
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 py-3>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs6 class="regulartext">Subtotal </v-flex>
                    <v-flex xs6 text-right class="RM"
                      >Rs. {{ tot.total }}
                    </v-flex>
                    <v-flex xs6 class="regulartext">Shipping</v-flex>
                    <v-flex xs6 text-right class="RM">Free </v-flex>
                    <v-flex xs12 py-3>
                      <v-divider> </v-divider>
                    </v-flex>
                    <v-flex xs6 class="regulartext">Total </v-flex>
                    <v-flex xs6 text-right class="RM" style="font-size: 23px"
                      >Rs. {{ tot.total }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      hover: false,
      msg: "",
      timeout: 5000,
      column: null,
      snackbar: false,
      appLoading: false,
      ServerError: false,
      dialog: false,
      radios: null,
      cart: [],
      tot: [],
      ship: [],
      qty: 1,
      editingitem: {
        firstName: null,
        lastName: null,
        company: null,
        email: null,
        phone: null,
        address: null,
        pincode: null,
        city: null,
        state: null,
        country: null,
      },
      editdialog: false,
    };
  },
  mounted() {
    this.getData();
    this.getShipping();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/cart/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;
          this.tot = response.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getShipping() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/shippingAddress/view/" + this.id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ship = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/shippingAddress/edit/" + this.editingitem._id,
        data: this.editingitem,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Update Shipping Address Successully";
            this.getShipping();
            this.snackbar = true;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editShip(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
  },
};
</script>